import React, { useEffect, useState } from "react";
import styles from "./project.module.scss";
import { Button } from "@aqar-app/react-ui";
import ListingCard from "@/components/Listing/ListingCard";
import { fetchAllCategoryFields, usePath } from "@/contexts/path/path";
import { useQuery } from "@apollo/client";
import { GET_REAL_ESTATE_PROJECT_UNITS } from "@/graphql/queries/realestateProjects";
import FiltersUi from "@/components/filters/controls";
import { getProjectURL } from "./ProjectCard";
import { Icon } from "@/components/icon";
import {
  listingToEECItemObject,
  trackSelectItem,
} from "@/lib/tracking/trackEECEvents";
import { useAuthState } from "@/contexts/auth/auth.provider";
import { getMaintainedParam } from "@/lib/apolloClient";

const ProjectUnits = ({ listings, project, title, hideFilters }) => {
  const {
    toggleFilters,
    updateContext,
    category,
    city,
    district,
    categoriesDictionary,
    direction,
  } = usePath();
  const { token, user } = useAuthState();
  const [filterFields, setFilterFields] = React.useState([]);
  const [showFilters, setShowFilters] = React.useState(false);
  const [filters, setFilters] = useState({});
  const [units, setUnits] = useState(listings || []);

  const maintainedParam = getMaintainedParam(user?.cooperative);

  useQuery(GET_REAL_ESTATE_PROJECT_UNITS, {
    skip: !project,
    variables: {
      where: {
        project_id: { eq: project.id },
        published: { eq: 1 },
        ...maintainedParam,
        ...filters,
      },
    },
    onCompleted: (data) => {
      setUnits(data?.Search?.find?.projects?.[0]?.listings || []);
    },
  });

  useEffect(() => {
    // filters are the same here and do not depend on category.
    fetchAllCategoryFields(6).then((res) => {
      const searchFields =
        res?.searchFields
          ?.slice(0, 4)
          ?.map((field) => [FiltersUi[field.type], field]) || [];
      setFilterFields(searchFields);
    });
  }, []);

  return (
    <div className={styles.unitsSection}>
      <div className={styles.header}>
        <h4 className={styles.sectionTitle}>{title || "الوحدات"}</h4>
        {!hideFilters && (
          <Button theme="primary" onClick={() => setShowFilters(!showFilters)}>
            <Icon name="Slider-white" width={20} height={20} />
            <span>فلاتر</span>
          </Button>
        )}
      </div>
      <div className={styles.filtersContainer}>
        <div
          className={`${styles.filtersWrapper} ${
            showFilters ? styles.expand : ""
          }`}
        >
          <div className={styles.filters}>
            {filterFields.map(([Component, props]) => (
              <Component
                key={props.name}
                {...props}
                value={
                  filters?.[props?.name]?.[props?.operation] ||
                  filters?.[props?.name]
                }
                onChange={(name, value) => {
                  setFilters({
                    ...filters,
                    [name]: value,
                  });
                }}
              />
            ))}
          </div>
          <div className={styles.actions}>
            <Button theme="primary" onClick={toggleFilters}>
              <span>بحث</span>
            </Button>
            <Button
              theme="secondary"
              onClick={() => {
                setFilters({});
              }}
            >
              <span>إعادة ضبط</span>
            </Button>
          </div>
        </div>
      </div>

      <div>
        {units?.map((listing, index) => (
          <ListingCard
            listing={listing}
            onClick={() => {
              updateContext({
                unit: {
                  ...listing,
                  url: getProjectURL({
                    title: project.title,
                    id: project.id,
                    real_estate_developer: project.real_estate_developer,
                    unitCode: listing.unit_code,
                    unitId: listing.id,
                  }),
                },
              });
              trackSelectItem({
                itemListName: `project_units_${listing.id}`,
                listingType: category?.ga_listing_type,
                category: category?.en,
                cityName: city?.name_en,
                directionName: direction?.name_en,
                districtName: district?.name_en,
                filters,
                count: units.length,
                listings: units.map((unt, index) =>
                  listingToEECItemObject(unt, index, categoriesDictionary),
                ),
              });
            }}
            key={listing.id}
            index={index}
          />
        ))}
      </div>
    </div>
  );
};

export default ProjectUnits;
